import { CoverMainColor } from '../../../shared/enums';

const coverMainColors = Object.keys(CoverMainColor);

const getColorNameByValue = color =>
  (coverMainColors.find(key => CoverMainColor[key] === color) || '').toLowerCase();

export default getColorNameByValue;
